/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoomsDeviceResponseDto } from './RoomsDeviceResponseDto';
export type RoomsResponseDto = {
  id: number;
  name: RoomsResponseDto.name;
  customName?: string;
  devices: Array<RoomsDeviceResponseDto>;
  createdAt: string;
};
export namespace RoomsResponseDto {
  export enum name {
    LIVING_ROOM = 'LIVING_ROOM',
    BEDROOM = 'BEDROOM',
    KITCHEN = 'KITCHEN',
    BATHROOM = 'BATHROOM',
    CHILDS_ROOM = 'CHILDS_ROOM',
    GARAGE = 'GARAGE',
    SUMMER_HOUSE = 'SUMMER_HOUSE',
    OTHER = 'OTHER',
  }
}

